var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconActivitat = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Activitats") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici/Menu-Obert",
  transform: "translate(-31.000000, -254.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-Lateral",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Activitat",
  transform: "translate(31.000000, 166.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconActivitat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_activitat.a0baecb8ed84ec944b97a77126f09c7e.svg";